import { renderToStaticMarkup } from "react-dom/server";

const waitImages = (doc) => Promise.all([...doc.images].map((img) => (img.complete ? null : new Promise((r) => { img.onload = r; img.onerror = r; }))));

// Prints HTML inside an isolated iframe so the app layout never interferes with the printout.
export async function printHtml(html, { pageCss = "", title = "print" } = {}) {
  const frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  Object.assign(frame.style, { position: "fixed", right: "0", bottom: "0", width: "0", height: "0", border: "0" });
  document.body.appendChild(frame);
  const doc = frame.contentDocument;
  doc.open();
  doc.write(`<!doctype html><html><head><meta charset="utf-8"><title>${title}</title>
<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600;700&family=Manrope:wght@400;600;700&display=swap">
<style>*{box-sizing:border-box;-webkit-print-color-adjust:exact;print-color-adjust:exact}html,body{margin:0;padding:0;background:#fff}${pageCss}</style></head><body>${html}</body></html>`);
  doc.close();
  await waitImages(doc);
  try { await Promise.race([doc.fonts?.ready, new Promise((r) => setTimeout(r, 1500))]); } catch (e) {}
  await new Promise((r) => setTimeout(r, 150));
  frame.contentWindow.focus();
  frame.contentWindow.print();
  setTimeout(() => frame.remove(), 2000);
}

export const receiptPageCss = (tpl) => `@page{size:${tpl.paper_mm}mm auto;margin:0}body{width:${tpl.paper_mm}mm}`;
export const a4PageCss = () => `@page{size:A4 portrait;margin:0}body{width:210mm}`;

export const printElement = (el, opts) => printHtml(renderToStaticMarkup(el), opts);
